import React,{Component} from 'react'
import {Container, Table, Button, ButtonToolbar} from 'react-bootstrap'
import {WorkerModal} from './WorkerModal'
import { ToId, ToDate } from '../../../components/Shared/ViewControl'
import Header from '../../Header'

export class Worker extends Component{

    constructor (props){
        super(props)
        this.state = {items:[], itemId:0, modalShow:false, mode:0, search:''}
        this.route='sync/worker'
    }

    componentDidMount(){
        this.Load()
    }

    componentWillUnmount() {
        this.setState({items:[]})        
        //document.removeEventListener("click", this.closeMenu);
    }
    
    Load() {
        this.props.global.GET(this.route)
        .then(data => this.setState({items:data}))
        .catch(error => console.log({ error }))
    }    
    
    Delete(id) {
        this.props.global.DELETE(this.route, id)
        .then(()=> this.Load())
    }

    modalClose =() => {
        this.setState({modalShow:false})
        this.Load()
    }

    onSearch = (value) => {
        this.setState({search:value})        
        this.forceUpdate();
    }

    render() {

        const filtered = this.state.items.filter(
            (item)=>{
            return (item.Name+' '+item.Description+' '+item.DriveIn.toString()+' '+item.DriveOut.toString()).indexOf(this.state.search)!==-1;
        })


        return (
            <Container>

        <Header lang={this.props.lang} service={'Synchronize'} account={this.props.account} onSearch={this.onSearch} />
            
<Table className="mt-3" striped hover bordered size="sm">
<thead>
    <tr>
        <th>Id</th>
        <th>Name</th>
        <th>Description</th>
        <th>DriveIn</th>
        <th>DriveOut</th>
        <th>Priority</th>
        <th>Option</th>
        <th>Active</th>
        <th>Date</th>
        <th>
            <ButtonToolbar style={{ display: 'flex', justifyContent: 'center', width:'6em' }}>
            <Button variant='primary' onClick={()=>this.setState({modalShow:true, itemId:0, mode:2})}>
            +</Button>           
            </ButtonToolbar>
        </th> 
    </tr>
</thead>

<tbody>
    {
        filtered.map(item=>
            <tr key={item.Id}>
<ToId value={item.Id} onClick={()=> this.setState({modalShow:true,itemId:item.Id,mode:0})} selelcetd={this.state.itemId}/>
<td>{item.Name}</td>
<td>{item.Description}</td>
<td>{item.DriveIn}</td>
<td>{item.DriveOut}</td>
<td>{item.Priority}</td>
<td>{item.Option}</td>
<td>{item.Active.toString()}</td>
<ToDate value={item.Updated} />
<td style={{width:'2rem'}}>
    <ButtonToolbar>
        <Button className="mr-2" variant="info"
        onClick={()=> this.setState({modalShow:true,itemId:item.Id,mode:1})}
        ><i className="fa fa-edit"></i></Button>

        <Button className="mr-2" variant="danger"
        onClick={()=> this.Delete(item.Id)}
        ><i className="fa fa-trash"></i></Button>
    </ButtonToolbar>
</td>
            </tr>
            )
    }
</tbody>
</Table>

{this.state.modalShow ?

<WorkerModal 
    global={this.props.global}
    route={this.route}
    id={this.state.itemId}
    mode={this.state.mode}
    show={true}
    onHide={this.modalClose}
/>
: null}

</Container>


        )
    }
}